import { useSelect } from '@wordpress/data'


export const useTaxonomies = () => {

    const taxonomies = useSelect((select) => {
        const taxonomies = select('core').getTaxonomies() || []
        return taxonomies.map(taxonomy => ({
            ...taxonomy,
            terms: select('core').getEntityRecords('taxonomy', taxonomy.slug, { per_page: 100 }) || []
        }))
    })

    return taxonomies
};

export default useTaxonomies